module.exports = __webpack_public_path__ + "static/media/keyoperation2.cd7875eb.png";